<template>
    <button class="fab-button"
            :disabled="disabled"
            @click="clickHandler"
            @mousedown="startRipple"
            @mouseup="endRipple"
            @mouseleave="cancelRipple"
            @touchstart="startRipple"
            @touchend="endRipple"
            @click.prevent="clickHandler"
    >
        <span class="fab-button__ripple-container"
              ref="rippleContainer"
        />
        <span class="fab-button__text">
            <slot />
        </span>
    </button>
</template>

<script>
import { DisabledMixin } from './mixins/disabled';
import { ClickRippleMixin } from './mixins/click-ripple';

export default {
    mixins: [ DisabledMixin, ClickRippleMixin ],
    mounted() {
        // Configure Ripple
        this.rippleConfig.container = this.$refs.rippleContainer;
        this.rippleConfig.duration = 1600;
        this.rippleConfig.color = `rgba(255, 255, 255, .4)`;
        this.rippleConfig.halfAnimationSize = 1;
        this.rippleConfig.position = {
            x: '50%',
            y: '50%'
        };
    },
    methods: {
        clickHandler(event) {
            this.$emit('click', event);
        }
    }
}
</script>

<style scoped lang="scss">
    .fab-button {
        position: relative;
        border-radius: 50%;
        border: 0;
        height: 3.5rem;
        width: 3.5rem;
        outline: 0;
        cursor: pointer;
        transition: background-color ease-out .2s;
        background-color: $color-action;

        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: inherit;
            opacity: 0;
            transition: opacity ease-out .2s;
            box-shadow: 0 5px 10px rgba($color-black, .2);
        }

        &:hover {
            background-color: darken($color-action, 2);

            &::before {
                opacity: 1;
            }
        }

        &[disabled] {
            background-color: $color-disabled;
        }
    }

    .fab-button__ripple-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .fab-button__text {
        @include icon-font;
        font-size: 1.5rem;
        line-height: 3.5rem;
        color: $color-action-contrast;
        text-align: center;
        width: 100%;
        height: 100%;

        .fab-button[disabled] & {
            color: $color-disabled-contrast;
        }
    }
</style>
